// Modal.js
import React from 'react';
 
const Popup = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
 
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-11/12 p-6 rounded shadow-lg relative">
        {/* Close button */}
        <button
          className="absolute rounded-full hover:bg-gray-200 px-2 top-2 text-xl right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};
 
export default Popup;